import { Message } from "element-ui";
import { OssUpload } from "@/class/upload.js";
import axios from "@/assets/js/request"
export class InOssUpload extends OssUpload {
    constructor() {
        super();
        this.headers = {}
        this.host = "https://oytqc-oss.oss-cn-qingdao.aliyuncs.com";
        this.action = this.host;
        this.formData = {
            policy: undefined,
            signature: undefined,
            ossaccessKeyId: undefined,
            key: undefined,
            dir: undefined,
            host: undefined,
            timeStamp: undefined,
            fileName: undefined,
        };
        this.modular = "FBAContainer"
        this.modularType = "pdf"
        this.response = []//上传成功前的自定义返回
        //签名    //与upload的区别
        this.signaFile = async (EXT,name) => {
            await axios.get("aliyun/oss/policy").then(response => {
                const timestamp = new Date().getTime() + Math.round(Math.random() * 998 + 1); //时间戳，用来生成编号。
                this.formData.policy = response.data.data.policy;
                this.formData.signature = response.data.data.signature;
                this.formData.ossaccessKeyId = response.data.data.accessKeyId;
                this.formData.key = response.data.data.dir + `/${this.modular}/` + timestamp + `${EXT}`;
                this.formData.dir = response.data.data.dir + `/${this.modular}`;
                this.formData.host = response.data.data.host;
                this.formData.timeStamp = timestamp;
                this.formData.fileName = this.action + '/' + this.formData.dir + '/' + timestamp + `${EXT}`;
                //由于上传状态204无返回结果，需记录文件名称及路径，在上传成功后把结果加入对象中
                this.response.push({
                    code: 200,
                    data: {
                        fileName: name,
                        filePath: this.formData.fileName,
                    }
                })
                //file-name
            })
        }
        this.beforeUpload = async (file) => {
            // console.log('beforeUpload',file)
            // //上传前验证文件
            const { el } = this;
            const { name, type, size } = file;
            console.log("beforeUpload--", file);
            return new Promise(async (resolve, reject) => {
                if (size > el.size) {
                    Message.error(`文件超过${el.size / 1024 / 1024} MB，无法上传`);
                    this.isBeforeDel = true
                    reject(false)
                }
                try {
                    let idx = name.lastIndexOf(".");
                    if (idx > -1) {
                        let EXT = name.slice(idx);
                        let key = EXT.slice(1);
                        if (el.accept.includes(EXT) && el.acceptObject[key].includes(type)) {
                            console.log('---beforeUpload---true')
                            await this.signaFile(EXT,name)    //与upload的区别
                            this.isBeforeDel = false
                            resolve(true)
                        } else {
                            Message.error(this.$t("upload.typeErr"));
                            this.isBeforeDel = true
                            reject(false);
                        }
                    }
                } catch (err) {
                    //扩展名未加入到对象,el.acceptObject[key] 为undefined，el.acceptObject[key].includes(type)
                    Message.error(this.$t("upload.typeErr"));
                    this.isBeforeDel = true
                    reject(false)
                }
            })

        };
        this.onSuccess = (result, uploadFile) => {
            console.log("on-success", uploadFile);
            let thisResponse = this.response.filter((item)=>{return item.data.fileName == uploadFile.name})
            //把上传记录的结果，加入对象中
            uploadFile.response = thisResponse[0]  //与upload的区别
            const data = uploadFile?.response?.data || uploadFile
            this.el.successResult = data;
            this.el.fileList.push({
                url: data.filePath || data.url,
                name: data.fileName || data.name,
            });
            if (!this.el.multiple) {
                //在多选状态时，el不可修改fileList，
                //非多选状态时，才可修改。。由于mp4是自定义预览，需要读取fileList文件，即需要修改fileList，
                //最终结论为：自定义预览的mp4,不可使用多选。。而其它非自定义预览的jpg等，可使用多选状态
                this.updateFiles()
            }

            this.modeString();
            this.modeObject();
            this.modeArray();
            this.el.emit();
        };
    }
}

